import styled from '@emotion/styled'
import { BackdropModal } from '@helpers/styles'

const BackdropWithModalStyles = styled(BackdropModal)`
	.add-members-modal-action-part {
		width: 100%;
		display: flex;
		justify-content: flex-end;
		padding-top: 12px;

		.add-members-modal-cancel-button {
			margin-right: 10px;
		}
	}
`

export { BackdropWithModalStyles }
